import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

const LANGUAGES = [
    { code: 'fr', label: 'Français', flag: 'fi-fr' },
    { code: 'en', label: 'English', flag: 'fi-gb' },
    { code: 'es', label: 'Español', flag: 'fi-es' },
    { code: 'de', label: 'Deutsch', flag: 'fi-de' }
];

function LanguageSelect({ value, onChange }) {
    const [show, setShow] = useState(false);
    const selected = LANGUAGES.find(lang => lang.code === value) || LANGUAGES[0];

    return (
        <Dropdown show={show} onToggle={(show) => setShow(show)} className="w-100">
            <Dropdown.Toggle
                variant="light"
                className="w-100 d-flex align-items-center justify-content-between"
            >
                <span className="d-flex align-items-center">
                    <i className={`fi ${selected.flag} me-2`}></i>
                    {selected.label}
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="w-100">
                {LANGUAGES.map((lang) => (
                    <Dropdown.Item
                        key={lang.code}
                        onClick={() => {
                            onChange(lang.code);
                            setShow(false);
                        }}
                        active={value === lang.code}
                    >
                        <i className={`fi ${lang.flag} me-2`}></i>
                        {lang.label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default LanguageSelect;
